export const Collapse = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2236_3434)">
        <path
          d="M2.8125 13.625C2.8125 13.9344 3.06562 14.1875 3.375 14.1875L14.625 14.1875C14.9344 14.1875 15.1875 13.9344 15.1875 13.625L15.1875 2.375C15.1875 2.06563 14.9344 1.8125 14.625 1.8125L3.375 1.8125C3.06562 1.8125 2.8125 2.06563 2.8125 2.375L2.8125 13.625ZM3.375 15.875C2.13398 15.875 1.125 14.866 1.125 13.625L1.125 2.375C1.125 1.13398 2.13398 0.125 3.375 0.125L14.625 0.125C15.866 0.125 16.875 1.13398 16.875 2.375V13.625C16.875 14.866 15.866 15.875 14.625 15.875L3.375 15.875ZM5.625 8C5.625 7.76445 5.72344 7.54297 5.8957 7.38125L9.8332 3.725C10.0793 3.49648 10.4379 3.43672 10.7438 3.57031C11.0496 3.70391 11.25 4.00977 11.25 4.34375L11.25 11.6562C11.25 11.9902 11.0496 12.2961 10.7438 12.4297C10.4379 12.5633 10.0793 12.5035 9.8332 12.275L5.8957 8.61875C5.72344 8.46055 5.625 8.23555 5.625 8Z"
          fill="#94A3B8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2236_3434">
          <rect
            width="15.75"
            height="18"
            fill="white"
            transform="matrix(0 -1 1 0 0 15.875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
